import { render } from "./articleSearch.vue?vue&type=template&id=d6c3d966"
import script from "./articleSearch.vue?vue&type=script&lang=js"
export * from "./articleSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__